/** Matches {@link OfflineSyncApplicationService} pending-offline-upload filtering. */
export const SQL_WHERE_OFFLINE_UPLOAD_PENDING = `(offline_uploaded_at IS NULL OR trim(offline_uploaded_at) = '')`;
